/* eslint-disable */
import _ from 'lodash';
import qs from 'qs';

export const getPaginationFromMeta = (initial, currentPage, links) => {
  if(links === undefined || Object.keys(links).length === 0) {
    return initial;
  }
  
  const lastPage = links.last;
  
  let page = currentPage;
  if (lastPage) {
    page = qs.parse(lastPage.split('?')[1]).page;
  } else {
    page = qs.parse(links.self.split('?')[1]).page;
  }
  return page;
};

function addZero(number) {
  return number < 10 ? '0' + number : number;
}

export const dateFormatUK = (input) => {
  const date = new Date(input);
  let month = addZero(date.getMonth() + 1);
  let day = addZero(date.getDate());
  const year = date.getFullYear();

  return [day, month, year].join('/');
};

export const dateTimeFormat = (dateString) => {
  if (dateString) {
    const date = new Date(dateString);

    return [date.toLocaleDateString('en-GB'), date.toLocaleTimeString('en-GB')].join(' ');
  }
};

export const dateTimeFormatUK = (dateString) => {
  if (dateString) {
    const date = new Date(dateString);
    let hours = addZero(date.getUTCHours());
    let minutes = addZero(date.getMinutes());
    let seconds = addZero(date.getSeconds());

    return [dateFormatUK(dateString), [hours, minutes, seconds].join(':')].join(' ');
  }
};

export const arrayDiff = (arr1, arr2) => arr1.filter(x => arr2.includes(x));

export const dateFormat = (dateString) => {
  if (dateString) {
    const date = new Date(dateString);

    return date.toLocaleDateString('en-GB');
  }

  return '';
};

export const ucfirst = string => string.charAt(0)
  .toUpperCase() + string.substr(1);

export const deepSearch = (selector, obj) => {
  const p = selector.split('.');
  const len = p.length;
  for (let i = 0; i < len - 1; i++) {
    obj = obj[p[i]];
  }

  return obj[p[len - 1]];
};

export const destandard = (responseData) => {
  if (responseData && (typeof responseData === 'object')) {
    const nonStandardObject = {};

    Object.keys(responseData)
      .forEach((oldKey) => {
        const newKey = oldKey.split('-')
          .join('_');

        nonStandardObject[newKey] = responseData[oldKey];
      });

    return nonStandardObject;
  }

  return responseData;
};

export const createArray = obj => Object.keys(obj)
  .map((curr, index) => obj[curr]);

export const stringToSnakeCase = (str) => str.replace(/[^a-z0-9]/gi, '_').toLowerCase();

export const isRrfFormValid = (formState) => {
  const options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {async: true};

  if (!formState) return true;

  if (!formState.$form) {
    const errors = formState.errors;

    if (!Array.isArray(errors) && !_.isPlainObject(errors)) {
      return !options.async && formState.asyncKeys || !errors;
    }

    return Object.keys(formState.errors)
      .every((errorKey) => {
        if (!options.async && Array.isArray(formState.asyncKeys) && !!~formState.asyncKeys.indexOf(errorKey)) {
          return true;
        }

        return !formState.errors[errorKey];
      });
  }

  return Object.keys(formState)
    .every(key => isRrfFormValid(formState[key], options));
};

export const clearString = string => string.replace(/\W/g, '')
  .toLowerCase();

export const convertToFormData = (model, json) => {
  const formData = new FormData();

  Object.keys(json).forEach(key => {
    if (Array.isArray(json[key])) {
      if (json[key].length === 0) {
        formData.append(`${model}[${key}][]`, '');
      } else {
        json[key].forEach(value => formData.append(`${model}[${key}][]`, value));
      }
    } else {
      if(json[key] && json[key].constructor == Object) {
        const nestedFields = Object.entries(json[key]);
        for (const [fieldName, fieldData] of nestedFields) {
          formData.append(`${model}[${key}][${fieldName}]`, fieldData);
        }
      } else {
        formData.append(`${model}[${key}]`, json[key])
      }
    }
  });

  return formData;
};

// takes a {} object and returns a FormData object
export const objectToFormData = (model, namespace, form) => {
  let fd = form || new FormData();

  for (let propertyName in model) {
    if (!model.hasOwnProperty(propertyName) ||
      (!model[propertyName]
        && !propertyName.includes('_target_')
        && propertyName !== 'all_groups'
        && propertyName !== 'price_rrp'
        && propertyName !== 'price_list'
        &&  propertyName !== 'points_threshold')) continue;

    let formKey = namespace ? `${namespace}[${propertyName}]` : propertyName;

    if (model[propertyName] instanceof Date) {
      fd.append(formKey, model[propertyName].toISOString());
    } else if (model[propertyName] instanceof Array) {
      const tempFormKey = `${formKey}[]`;
      if (!(model[propertyName].length)) {
        fd.append(tempFormKey, '');
      } else {
        model[propertyName].forEach((element) => {
          if (typeof element === 'object') {
            objectToFormData(element, tempFormKey, fd);
          } else {
            fd.append(tempFormKey, element);
          }
        });
      }
    } else if (typeof model[propertyName] === 'object' && !(model[propertyName] instanceof File))
      objectToFormData(model[propertyName], formKey, fd);
    else {
      fd.append(formKey, model[propertyName]);
    }
  }

  return fd;
};

export const removeNullFieldsFromJson = (data) => {
  const copy = {...data};

  Object.keys(copy).forEach(key => {
    copy[key] = copy[key] || '';
  });

  return copy;
};



// WEBPACK FOOTER //
// ./src/utils/commonFunctions.js